import React from "react";
import { Box, Button, Skeleton, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CommonSection } from "../../../components/common/CommonSection";
import Ratings from "../../../components/common/Ratings";
import { PreviewImage } from "../ProductDetails";
import { motion } from "framer-motion";

function ProductDetailsSkeleton({ fallbackImage, layoutId }) {
  return (
    <>
      <CommonSection sx={{ mt: 3 }}>
        <Skeleton variant="text" width="30%" height={40} />
        {/* <Grid container spacing={5} rowGap={4} sx={{ mt: 4 }}>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Box sx={{ position: "sticky", top: "136px" }}>
              <Grid container spacing={5}>
                <Grid size={2.5} sx={{ display: { xs: "none", sm: "block" } }}>
                  <Stack direction="column" spacing={2}>
                    {Array.from(new Array(3)).map((item, index) => (
                      <Skeleton
                        key={index}
                        variant="rounded"
                        width="95%"
                        height={90}
                        border
                      />
                    ))}
                  </Stack>
                </Grid>
                <Grid
                  size={8.5}
                  gap={3}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <motion.div layoutId={layoutId} sx={{ width: "100%" }}>
                    <PreviewImage
                      src={fallbackImage}
                      transition={{ duration: 0.3 }}
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "400px",
                        borderRadius: "8px",
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        border: "0px solid #e0e0e0",
                        padding: "0px",
                      }}
                    />
                  </motion.div>

                  <Grid container spacing={3}>
                    <Grid size={6}>
                      <Skeleton variant="rounded" width="100%" height={55} />
                    </Grid>
                    <Grid size={6}>
                      <Skeleton variant="rounded" width="100%" height={55} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton variant="text" width="60%" height={40} />
              </Box>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", gap: 3 }}
              >
                <Ratings
                  value={4}
                  styles={{ color: "#FF9900", fontSize: "24px" }}
                  ratingNumberstyles={{
                    fontWeight: 600,
                    fontSize: "18px",
                    color: "var(--neutral-black)",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />
                  <Stack direction="row" spacing={2}>
                    {Array.from(new Array(3)).map((item, index) => (
                      <Skeleton
                        variant="rounded"
                        width="15%"
                        height={45}
                        key={index}
                      />
                    ))}
                  </Stack>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />
                  <Skeleton variant="rounded" width="20%" height={40} />
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ alignItems: "center" }}
                >
                  <Skeleton variant="text" width="25%" height={60} />
                </Stack>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />

                  <Skeleton variant="rectangular" width="80%" height={48} />
                </Box>
              </Box>
            </Box>
            <Grid size={12} sx={{ mt: 4 }}>
              <Skeleton variant="text" width="10%" height={30} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="10%" height={20} />
            </Grid>
            <Grid size={12} sx={{ mt: 4 }}>
              <Skeleton variant="text" width="10%" height={30} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="10%" height={20} />
            </Grid>
          </Grid>
        </Grid> */}
        <Grid
          container
          spacing={5}
          rowGap={4}
          sx={{ mt: { xs: 2, sm: 3, md: 4 } }}
        >
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ position: "sticky", top: "136px" }}>
              <Grid container spacing={5}>
                <Grid
                  size={{ xs: 12, md: 2.5 }}
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  <Stack direction="column" spacing={2}>
                    {Array.from(new Array(3)).map((item, index) => (
                      <Skeleton
                        key={index}
                        variant="rounded"
                        width="95%"
                        height={90}
                        border
                      />
                    ))}
                  </Stack>
                </Grid>
                <Grid
                  size={{ xs: 12, md: 9.5 }}
                  gap={3}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <motion.div layoutId={layoutId} sx={{ width: "100%" }}>
                    <PreviewImage
                      src={fallbackImage}
                      transition={{ duration: 0.3 }}
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "400px",
                        borderRadius: "8px",
                        backgroundColor: "#f0f0f0",
                        display: "flex",
                        border: "0px solid #e0e0e0",
                        padding: "0px",
                      }}
                    />
                  </motion.div>

                  <Grid container spacing={3}>
                    <Grid size={6}>
                      <Skeleton variant="rounded" width="100%" height={55} />
                    </Grid>
                    <Grid size={6}>
                      <Skeleton variant="rounded" width="100%" height={55} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Skeleton variant="text" width="60%" height={40} />
              </Box>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", gap: 3 }}
              >
                <Ratings
                  value={4}
                  styles={{ color: "#FF9900", fontSize: "24px" }}
                  ratingNumberstyles={{
                    fontWeight: 600,
                    fontSize: "18px",
                    color: "var(--neutral-black)",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />
                  <Stack direction="row" spacing={2}>
                    {Array.from(new Array(3)).map((item, index) => (
                      <Skeleton
                        variant="rounded"
                        width="15%"
                        height={45}
                        key={index}
                      />
                    ))}
                  </Stack>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />
                  <Skeleton variant="rounded" width="20%" height={40} />
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ alignItems: "center" }}
                >
                  <Skeleton variant="text" width="25%" height={60} />
                </Stack>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Skeleton variant="text" width="10%" height={30} />

                  <Skeleton variant="rectangular" width="80%" height={48} />
                </Box>
              </Box>
            </Box>
            <Grid size={12} sx={{ mt: 4 }}>
              <Skeleton variant="text" width="10%" height={30} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="10%" height={20} />
            </Grid>
            <Grid size={12} sx={{ mt: 4 }}>
              <Skeleton variant="text" width="10%" height={30} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="10%" height={20} />
            </Grid>
          </Grid>
        </Grid>
      </CommonSection>
    </>
  );
}

export default ProductDetailsSkeleton;
